<template>
  <div>
    <b-loading isFullPage :active="isLoading" />
    <b-tabs>
      <b-tab-item>
        <template slot="header">
          <span class="has-text-weight-bold"
            >{{ General.APPENDED_PROCESS }}
          </span>
        </template>
        <div
          v-for="appendedProcess in getAppendedProcesses"
          :key="appendedProcess.id"
          class="process-list"
        >
          <div class="process-info" @click="goToAppended(appendedProcess.id)">
            <p class="has-text-weight-semibold">
              {{ `${General.NUP} ${applyMaskNUP(appendedProcess.nup)}` }}
            </p>
            <p class="is-size-7">
              <span class="has-text-weight-semibold"
                >{{ General.SUBJECT }}:
              </span>
              <span class="is-capitalized">
                {{ appendedProcess.subject.toLowerCase() }}
              </span>
            </p>
            <p class="is-size-7">
              <span class="mobile-container">
                <span class="has-text-weight-semibold">
                  {{ General.ADDED_ON }}
                </span>
                {{ new Date(appendedProcess.date) | dateFormat("DD-MM-YYYY") }}
                às
                {{
                  `${new Date(appendedProcess.date).getHours()}h${new Date(
                    appendedProcess.date
                  ).getMinutes()}m`
                }}
              </span>
              <span>
                <span class="has-text-weight-semibold">{{ General.PER }}</span>
                <span class="is-capitalized">
                  {{
                    `${appendedProcess.origin.entity.abbreviation}/${
                      appendedProcess.origin.abbreviation.includes("/")
                        ? appendedProcess.origin.abbreviation.split("/")[1]
                        : appendedProcess.origin.abbreviation
                    } - ${appendedProcess.origin.description.toLowerCase()}`
                  }}
                </span>
              </span>
            </p>
          </div>
          <div>
            <ActionsGrouper :actions="actionList(appendedProcess)" />
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import ModalUnappendProcess from "@/views/App/ModalUnappendProcess";
import {
  PROCESS_DETAILS_TABS as TABS,
  USER_PERMISSIONS as userPermissions
} from "@/utils/enumerate";

export default {
  name: "JointList",
  props: {
    processId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      General,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getAppendedProcesses: "getAppendedProcesses",
      getCurrentProcess: "getCurrentProcess",
      hasPermission: "hasPermission"
    }),

    hasPermissionUnappend() {
      return this.hasPermission(userPermissions["UNAPPEND_PROCESS"]);
    }
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getProcessAppended(this.processId);
    this.isLoading = false;
  },
  methods: {
    ...mapMutations({
      setCurrentTab: "setCurrentTabProcessDetails"
    }),

    ...mapActions({
      getProcessAppended: "getProcessAppended",
      getCompleteProcessFileStream: "getCompleteProcessFileStream",
      simpleMyProcessListRequest: "simpleMyProcessListRequest"
    }),

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    goToAppended(processId) {
      this.setCurrentTab(TABS.BASIC_DATA.value);
      window.location.replace(`/app/processos/detalhamento/${processId}`);
    },

    async reloadJointTabProcessList() {
      this.isLoading = true;
      await this.getProcessAppended(this.processId);
      this.isLoading = false;
    },

    unappendProcess(appendedProcess) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalUnappendProcess,
        props: {
          appendedProcess,
          onClose: async () => await this.reloadJointTabProcessList()
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    actionList(item) {
      return [
        {
          label: this.General.TO_VIEW,
          icon: "magnify-plus",
          callback: () => this.getCompleteProcessFileStream(item.id)
        },
        {
          label: this.General.UNAPPEND,
          icon: "link-variant-remove",
          permission: this.hasPermissionUnappend,
          validated: this.getCurrentProcess.id === item?.process_join,
          callback: () => this.unappendProcess(item)
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.process-list {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  justify-content: space-between;
  border-top: 1px solid $grey-lighter;
  border-bottom: 1px solid $grey-lighter;

  @media screen and (max-width: $tablet) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;

    .mobile-container {
      display: flex;
      flex-direction: column;
    }
  }

  .process-info {
    flex: 1;
    cursor: pointer;
  }
}
</style>
